
        import {css} from 'lit';
        export default css`svg{max-width:160px;max-height:160px}`;
    